import { EntityRepository, Repository } from "typeorm";
import { GradeInventory } from "../entities/grade-inventory.entity";

@EntityRepository(GradeInventory)
export class GradeInventoryRepository extends Repository<GradeInventory> {

    
}